<div class="cart_item" [class.duplicate-item]="duplicateBooking">
  <div class="cart_item_wrapper">
    @if (eurostar?.detail; as flightDetail) {
      @if (eurostarToDisplay.detail.flights; as flights) {
        <div class="cart_item_heading">
          @for (
            flightDetail of flights;
            track flightDetail;
            let first = $first;
            let index = $index
          ) {
            <div [class.duplicate-item-info]="duplicateBooking">
              @if (!first) {
                <div class="section-spacer"></div>
              }
              <div>
                @if (!duplicateBooking) {
                  <i class="custom_icon-eurostar"></i>&nbsp;
                }
                <strong>
                  {{ getFullStationName(flightDetail.originAirport) }} <span i18n="@@to">to</span
                  >{{ getFullStationName(flightDetail.destinationAirport) }}</strong
                >
              </div>
            </div>
            @if (first && !duplicateBooking) {
              <section (mouseleave)="tt1.close()">
                <button
                  class="cart_item_remove ico-trash"
                  ngbTooltip="Remove {{ flightDescription }} from your {{
                    (displayItinerary ? 'itinerary' : 'basket') | translate
                  }}"
                  attr.aria-label="Remove {{ getFullStationName(flightDetail.originAirport) }} to {{
                    getFullStationName(flightDetail.destinationAirport)
                  }} eurostar from your {{
                    (displayItinerary ? 'itinerary' : 'basket') | translate
                  }}"
                  i18n-aria-label
                  i18n-ngbTooltip
                  (click)="remove.emit()"
                  triggers="manual"
                  #tt1="ngbTooltip"
                  (mouseenter)="tt1.open()"
                  (focus)="tt1.open()"
                  (blur)="tt1.close()"
                  id="remove-basketitem-{{ eurostar.id }}"
                ></button>
              </section>
            }
            @if (first && !duplicateBooking) {
              <section (mouseleave)="tt2.close()">
                <img
                  src="https://images.sabscorp.com/images/enterprise/lightUK/assets/svg/{{
                    displayItinerary ? 'luggage_icon' : 'basket_move'
                  }}.svg"
                  class="move_basket_icon"
                  role="button"
                  attr.aria-label="Move {{ getFullStationName(flightDetail.originAirport) }} to {{
                    getFullStationName(flightDetail.destinationAirport)
                  }} eurostar to different {{
                    (displayItinerary ? 'itinerary' : 'basket') | translate
                  }}"
                  (click)="openChangeModal.emit()"
                  i18n-aria-label
                  ngbTooltip="Move to different {{
                    (displayItinerary ? 'itinerary' : 'basket') | translate
                  }}"
                  i18n-ngbTooltip
                  (keydown.enter)="openChangeModal.emit()"
                  (keydown.space)="openChangeModal.emit()"
                  triggers="manual"
                  #tt2="ngbTooltip"
                  (mouseenter)="tt2.open()"
                  (focus)="tt2.open()"
                  (blur)="tt2.close()"
                  tabindex="0"
                  id="share-basketitem-{{ eurostar.id }}"
                />
              </section>
            }
            @if (!duplicateBooking) {
              <div class="eurostar-details">
                <div>
                  <span i18n="@@itineraryDepart">Depart:</span>
                  {{ flightDetail.dateTimeDeparting | sabsDate: 5 }}
                </div>
                <div>
                  <span i18n="@@itineraryArrive">Arrives:</span>
                  {{ flightDetail.dateTimeArriving | sabsDate: 5 }}
                </div>
                <div>
                  <span i18n="@@flightBasketOperatedBy">Operated by:</span>
                  <span i18n="@@eurostar">Eurostar</span>
                </div>
                @if (flightDetail.fareInfo?.title || flightDetail.cabinClass) {
                  <div>
                    <span i18n="@@myBookingsItemDetailsRailTicket">Ticket:</span>
                    {{
                      flightDetail.fareInfo?.title || (flightDetail.cabinClass | splitCamelCase)
                        | translate
                    }}
                    <a
                      tabindex="0"
                      role="button"
                      class="fare_rules_link"
                      (click)="openFareRules()"
                      (keydown.enter)="openFareRules()"
                      aria-label="Fare rules"
                      i18n-aria-label
                    >
                      <i class="currency_info_icon" aria-hidden="true"></i>
                    </a>
                  </div>
                }
              </div>
            }
          }
        </div>
      }
      @if (!duplicateBooking) {
        @for (user of travellers; track user) {
          <div class="traveller-name">
            <b>{{ user.forename }}, {{ user.surname }}</b>
          </div>
        }
      }
      <div class="cart_item_price">
        @if (duplicateBooking) {
          <strong i18n="@@cost">Cost</strong>
        }
        <strong>{{ eurostar?.price | currency: eurostar?.currency }}</strong
        >&nbsp;
        @if (!duplicateBooking) {
          <em i18n="@@totalPrice"> Total Price </em>
        }
      </div>
    }
  </div>
</div>
